import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { droneService } from '../services/droneService';
import { setDrones, setLoading, setError } from '../store/slices/dronesSlice';
import { RootState } from '../store/store';

export const useDroneData = () => {
  const dispatch = useDispatch();
  const { drones, selectedDroneId, loading, error, refreshNonce } = useSelector(
    (state: RootState) => state.drones
  );

  useEffect(() => {
    const fetchDrones = async () => {
      try {
        dispatch(setLoading(true));
        const dronesData = await droneService.getAllDrones();
        dispatch(setDrones(dronesData));
      } catch (err) {
        dispatch(setError(err instanceof Error ? err.message : 'Failed to fetch drones'));
      }
    };

    fetchDrones();
    // refreshNonce re-runs this on demand — after enrolling a drone, or when
    // telemetry arrives for one this client has never seen (#480). Without it
    // the fleet is a snapshot taken once at mount, and anything added later is
    // invisible until a page reload.
  }, [dispatch, refreshNonce]);

  return {
    drones: Object.values(drones),
    selectedDrone: selectedDroneId ? drones[selectedDroneId] : null,
    loading,
    error,
  };
};
